import { cva } from 'class-variance-authority';

/**
 * The native checkbox, styled through `accent-color`.
 *
 * Deliberately NOT a hidden input behind a drawn box. The native control keeps
 * the platform's own focus, disabled and pressed rendering, form participation
 * and screen-reader behaviour; a custom box re-implements all of it and gets
 * each of them slightly wrong.
 */
export const controlStyles = cva(
  ['size-4 shrink-0 rounded-control accent-accent', 'disabled:cursor-not-allowed disabled:opacity-60'],
  {
    variants: {
      invalid: {
        true: 'outline-1 outline-critical',
        false: '',
      },
    },
    defaultVariants: { invalid: false },
  },
);

export const fieldStyles = {
  /** The wrapping label: also the click target and the accessible name. */
  root: 'flex w-fit cursor-pointer items-start gap-2',
  text: 'flex flex-col gap-0.5',
  label: 'text-sm leading-none text-content',
  hint: 'text-xs text-content-muted',
  error: 'text-xs text-critical',
  disabled: 'cursor-not-allowed opacity-60',
} as const;